import React from 'react';
import { Margin, Text } from '@upgrade/react-components';
import { AwardImage } from './styles';

const Award = ({ image, imageAlt, url, description }) => {
  return (
    <Margin bottom="lg" top="md">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <AwardImage src={image} alt={imageAlt} />
      </a>
      {description && (
        <Margin top="sm">
          <Text color="contentWeak" aria-hidden="true">
            {description}
          </Text>
        </Margin>
      )}
    </Margin>
  );
};

export default Award;
